import { applicationUrl } from "@constants";
import i18n from "../../i18n";

export const logoutUser = () => {
  if (import.meta.env.MODE !== "test") {
    const spaLoginUrl = `${window.location.origin}/login?flashWarning=${i18n.t("global.errors.sessionError")}`;
    window.location.href = `${applicationUrl}/logout?redirect_url=${spaLoginUrl}`;
  }
};

export const getInitials = (name: string): string => {
  const parts = name.split(/\s+/).filter((part) => part.length > 0);

  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0][0].toUpperCase();

  const first = parts[0][0];
  const last = parts[parts.length - 1][0];

  return `${first}${last}`.toUpperCase();
};
